export const StudyAnalysis = {
  '学生Tab_知识点掌握': '知识点掌握',
  '知识点掌握加载中': '正在加载知识点掌握情况...',
  '知识点掌握未绑定': '当前课程老师还未开通多模态知识库',
  '知识点个数': '知识点个数',
  '练习总题数': '练习总题数',
  '章节掌握度': '掌握度 {rate}%',
  '练习题数': '练习题数',
  '答对': '对',
  '答错': '错',
  '所属章节': '所属章节',
  '掌握状态': '掌握状态',
  '掌握状态_已掌握': '已掌握',
  '掌握状态_正常': '正常',
  '掌握状态_需提高': '需提高',
  '掌握状态_未练习': '未练习',
  '暂无知识点学习数据': '暂无知识点学习数据',
  '知识点内容加载中': '正在加载知识点内容...',
  '薄弱项分析': '薄弱项分析',
  '加载中': '加载中...',
  '查看AI薄弱项分析': '查看 AI 薄弱项分析',
  'AI薄弱项摘要': 'AI 薄弱项摘要',
  '刷新分析': '刷新分析',
  '生成最新分析': '生成最新分析',
  '最新分析时间': '最新分析：{time}',
  '尚未生成分析': '尚未生成分析',
  '历史版本': '历史版本',
  '版本最新': '最新',
  '掌握率': '掌握率',
  '整体掌握度': '整体掌握度',
  '生成冷却提示': '请 {minutes} 分钟后再生成',
  '分析生成中': '分析生成中，请稍候…',
  '薄弱项未绑定知识库': '当前课程尚未绑定多模态知识库，无法进行薄弱项分析',
  '薄弱项分析入口描述': 'AI 汇总错题分布，生成专属巩固练习',
  '薄弱知识点数': '薄弱知识点数',
  '累计错题数': '累计错题数',
  '练习正确率': '练习正确率',
  '错题分布': '错题分布',
  '错题数': '错题数',
  '薄弱知识点列表': '薄弱知识点列表',
  '暂无薄弱知识点': '太棒了！暂无薄弱知识点',
  '错误率': '错误率',
  '做错': '做错',
  '练习': '练习',
  '次': '次',
  '开始巩固练习': '开始巩固练习',
  '获取练习失败': '获取练习失败，请稍后重试',
  '获取学习数据失败': '获取数据失败',
  '缺少必要参数': '缺少必要参数',
  '优先级_紧急': '紧急',
  '优先级_高': '高',
  '优先级_中': '中',
  '优先级_低': '低',
  '薄弱项分析蒙层标题': '尚未生成 AI 薄弱项分析',
  '薄弱项分析蒙层说明': '生成后将展示 AI 摘要、错题分布与薄弱知识点巩固建议。分析约需数分钟，请耐心等待。',
  '薄弱项分析蒙层按钮': '立即生成分析',
  '薄弱项分析蒙层提示': '也可点击上方「生成最新分析」',
  '分析进度_汇总错题': '正在汇总错题数据…',
  '分析进度_统计薄弱点': '正在统计薄弱知识点…',
  '分析进度_AI生成摘要': 'AI 正在生成分析摘要…',
  '分析进度_即将完成': '即将完成，请稍候…',
  '巩固练习弹窗标题': '巩固练习',
  '学生Tab_我的学情画像': '我的学情画像',
  '画像加载中': '正在加载学情画像...',
  '暂无画像内容': '暂无画像内容',
  '画像图表加载失败': '图表加载失败',
}
